import { useEffect, useState } from 'react';
import { Copy, Bitcoin, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CryptoTipsPage() {
  const [wallets, setWallets] = useState({});
  const [prices, setPrices] = useState({});

  useEffect(() => {
    fetch(`${API}/public/crypto-wallets`).then(r => r.json()).then(d => setWallets(d.wallets || {}));
    fetch(`${API}/public/crypto-prices`)
      .then(r => r.json()).then(setPrices).catch(() => {});
  }, []);

  const copy = async (addr) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(addr);
      } else {
        const ta = document.createElement('textarea');
        ta.value = addr; document.body.appendChild(ta);
        ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      toast.success('Adresa kopirana');
    } catch {
      toast.error('Kopiranje nije uspjelo — ručno kopirajte adresu');
    }
  };

  const symbolMap = {
    trc20: { tag: 'tether', color: 'emerald' },
    btc: { tag: 'bitcoin', color: 'orange' },
    eth: { tag: 'ethereum', color: 'sky' },
    bnb: { tag: 'binancecoin', color: 'yellow' },
  };

  return (
    <div className="container mx-auto max-w-4xl px-4 py-10" data-testid="crypto-tips-page">
      <header className="mb-8 border-l-4 border-red-600 pl-4">
        <h1 className="text-4xl sm:text-5xl font-black text-gray-900 dark:text-gray-100 flex items-center gap-3">
          <Bitcoin className="text-red-500" size={40} /> Kripto napojnice
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Podržite naš rad kripto donacijom. Pošaljite na jednu od adresa ispod.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {Object.entries(wallets).map(([key, w]) => {
          const meta = symbolMap[key] || {};
          const price = prices[meta.tag]?.eur;
          return (
            <div key={key} data-testid={`wallet-${key}`}
                 className="p-5 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-[#0f172a] hover:border-red-500/50 transition">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-gray-400">{w.network}</div>
                  <div className="text-2xl font-black text-gray-900 dark:text-gray-100 mt-0.5">{w.symbol || w.label}</div>
                </div>
                {price && (
                  <div className="text-right">
                    <div className="text-[10px] text-gray-400 uppercase">Cijena</div>
                    <div className="text-sm font-bold text-emerald-500">€{Number(price).toLocaleString('hr-HR', {maximumFractionDigits: 2})}</div>
                  </div>
                )}
              </div>
              <div className="mt-3 p-3 bg-gray-50 dark:bg-black/40 rounded-lg border border-dashed border-gray-300 dark:border-gray-700">
                <code className="block text-[11px] break-all font-mono text-gray-700 dark:text-gray-200">{w.address}</code>
              </div>
              <button onClick={() => copy(w.address)} data-testid={`copy-wallet-${key}`}
                      className="mt-3 w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold">
                <Copy size={14} /> Kopiraj adresu
              </button>
            </div>
          );
        })}
      </div>

      <div className="mt-10 p-5 rounded-xl bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/40 text-sm text-amber-900 dark:text-amber-200">
        <strong>Napomena:</strong> Šaljite samo pripadnu kripto-valutu na svaku adresu. ETH i BNB dijele istu adresu, ali su na različitim mrežama (ERC-20 i BEP-20) — pazite prilikom slanja.
        <a href="https://www.coingecko.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 ml-2 underline">
          Tečaj: CoinGecko <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
